import React from 'react';
import { Col } from 'antd';
import { get, isEmpty } from 'lodash';
import Loading from 'components/Loading';

const IntegrationUserCard = ({ 
    integrationData, 
    title = "Integration User",
    userPath = 'users',
    fields = [],
    loading = false
}) => {
    const user = get(integrationData, userPath);
    
    if (loading) {
        return (
            <Col span={12} style={{ paddingLeft: "8px" }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <Loading size={20}/>
                </div>
            </Col>
        );
    }
    
    if (isEmpty(user)) return null;
    
    return (
        <Col span={12} style={{ paddingLeft: "8px" }}>
            <div style={{
                background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                borderRadius: '8px',
                padding: '12px',
                color: 'white',
                boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                border: '1px solid rgba(255,255,255,0.1)',
                height: '100%'
            }}>
                <div style={{
                    fontSize: '14px',
                    fontWeight: '700',
                    marginBottom: '12px',
                    textAlign: 'center',
                    color: '#ecf0f1',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }}>
                    {title}
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft: 56, paddingRight: 56 }}>
                    {fields.map((field, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                            <span style={{ color: '#bdc3c7', fontSize: '11px', fontWeight: '500', minWidth: '80px' }}>{field.label}:</span>
                            <span style={{ 
                                color: '#ecf0f1', 
                                fontSize: '11px', 
                                textAlign: 'right',
                                wordBreak: field.wordBreak ? 'break-all' : 'normal',
                                fontFamily: field.monospace ? 'monospace' : 'inherit'
                            }}>
                                {get(integrationData, field.path, '')}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </Col>
    );
};

export default IntegrationUserCard;
